import { ManageMentorGroupContainer } from "../manage/ManageMentorGroupCard"

function GroupManageAugmentation({ groupId }: { groupId: number }) {
  return <ManageMentorGroupContainer id={groupId} />
}

export default GroupManageAugmentation
